module.exports = __webpack_public_path__ + "img/E-WEB-Goal-15.cac49adc.png";